import {
    BrowserModule,
    BrowserTransferStateModule,
    Title,
} from '@angular/platform-browser';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { ToastrModule, ToastrService } from 'ngx-toastr';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
    BrowserAnimationsModule,
    NoopAnimationsModule,
} from '@angular/platform-browser/animations';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { AppCommonModule } from './common/common.module';
import { AppComponent } from './app.component';
import { MaterialModule } from './modules/material.module';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { TokenInterceptor } from './core/interceptors/token.interceptor';
import { CoreModule } from './core/core.module';
import { RouteUtilService } from './shared/utils/route-util.service';
import { MainComponent } from './common/main/main.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { SharedModule } from './shared/modules/shared.module';
import { NgxWebstorageModule } from 'ngx-webstorage';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { NgSelectModule } from '@ng-select/ng-select';
import { DatepickerComponent } from './shared/directives/datepicker/datepicker.component';
import { CommonModule, DatePipe } from '@angular/common';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { NgProgressModule } from "ngx-progressbar";
import { NgProgressHttpModule } from "ngx-progressbar/http";
import { MatTooltipModule } from '@angular/material/tooltip';
import { ErrorInterceptor } from './core/interceptors/error.interceptor';
import { BsDatepickerModule, BsDatepickerConfig } from 'ngx-bootstrap/datepicker';
import { NavigationComponent } from './common/navigation/navigation.component';
import { HeaderComponent } from './common/header/header.component';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { LoaderInterceptor } from './core/interceptors/loader.interceptor';
import { SpinnerComponent } from './common/spinner/spinner.component';
import { UserIdleModule } from 'angular-user-idle';


@NgModule({
    declarations: [
        AppComponent,
        MainComponent,
        DatepickerComponent,
        NavigationComponent,
        HeaderComponent,
        SpinnerComponent
    ],
    imports: [
        BrowserModule,
        BrowserTransferStateModule,
        BrowserAnimationsModule,
        HttpClientModule,
        FormsModule,
        ReactiveFormsModule,
        AppRoutingModule,
        AppCommonModule,
        CoreModule.forRoot(),
        MaterialModule,
        FontAwesomeModule,
        CoreModule,
        ToastrModule.forRoot(),
        MatAutocompleteModule,
        SharedModule,
        NgxWebstorageModule.forRoot(),
        MatInputModule,
        MatSelectModule,
        MatCardModule,
        MatIconModule,
        MatDialogModule,
        MatButtonModule,
        NgSelectModule,
        CommonModule,
        NgProgressModule.withConfig({
            color: "#0b50cede"
        }),
        NgProgressHttpModule,
        MatTooltipModule,
        BsDatepickerModule.forRoot(),
        MatProgressBarModule,
        // 2700 seconds = 45 mins
        UserIdleModule.forRoot({idle: 2700, timeout: 5}) 
    ],
    schemas: [NO_ERRORS_SCHEMA],
    providers: [
        { provide: 'windowObject', useValue: window },
        { provide: MAT_DATE_LOCALE, useValue: 'en-US' },
        {
            provide: MatDialogRef,
            useValue: {}
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: LoaderInterceptor,
            multi: true,
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: TokenInterceptor,
            multi: true,
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: ErrorInterceptor,
            multi: true
        },
        Title,
        ToastrService,
        RouteUtilService,
        DatePipe,
        BsDatepickerConfig,
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }
